import type { ReactNode } from 'react';
import clsx from 'clsx';
import { useResponsive } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';

interface HeaderProps {
  className?: string;
  action: ReactNode;
  children: ReactNode;
}

export const Header = (props: HeaderProps) => {
  const { isSmallScreen } = useResponsive();

  return (
    <h1
      className={clsx(
        'text-xl flex justify-between text-[#dadada] mt-5 mb-6 items-center relative max-[840px]:h-15 max-[840px]:m-0 max-[840px]:pl-15 max-[840px]:bg-[#1e1e21] max-[840px]:text-center max-[840px]:fixed max-[840px]:top-0 max-[840px]:w-full max-[840px]:z-50',
        PaletteUtils.isBordierPalette && 'text-[22px] !text-[#4d3b2c]',
        props.className,
      )}
    >
      {isSmallScreen && (
        <div className='absolute left-[-70px] pt-8 pr-[50px] cursor-pointer'>
          <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='-7 -2 20 20'>
            <path fill='currentColor' d='M0 1.75L5.595 7.5 0 13.25 1.703 15 9 7.5 1.703 0z' />
          </svg>
        </div>
      )}

      <span
        className={clsx('flex items-center max-[840px]:my-0 max-[840px]:mx-auto text-[22px] ', PaletteUtils.isBordierPalette && 'text-[#4d3b2c]')}
      >
        {props.children}
      </span>
      <div className={'flex flex-basis-15 justify-end'}>{props.action}</div>
    </h1>
  );
};
